const styles = theme => ({
  noResults: {
    height: '50vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
  },
  noResultsImage: {
    width: 150,
    marginBottom: theme.spacing.unit * 2,
  },
  button: {
    marginTop: theme.spacing.unit,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/components/map/GridContainer/NoResults/styles.js